<script setup>
// Header bell for the staff inbox (#141, notifications-v2 only): opens the
// inbox and shows the unread count. The store loads on app open and login
// (App.vue, LoginPage) and on arrival; this only refreshes the count.
import { computed, onMounted } from 'vue'
import { IconBell } from '@tabler/icons-vue'
import { useInboxStore } from '@/stores/inbox.js'
import { unreadLabel } from '@/services/inbox.js'

// floating: on pages without a header (home, hub), beside the floating menu button
defineProps({ floating: { type: Boolean, default: false } })

const inbox = useInboxStore()
const d = __DICT__.inbox
const label = computed(() => unreadLabel(inbox.unread))
const ariaLabel = computed(() => (inbox.unread ? `${d.bell}, ${inbox.unread} ${d.unread}` : d.bell))

onMounted(() => {
  if (inbox.enabled) inbox.refreshUnread()
})
</script>

<template>
  <RouterLink v-if="inbox.enabled" to="/inbox" class="btn btn-icon btn-ghost-secondary inbox-bell"
              :class="floating ? 'inbox-bell-floating position-absolute' : 'position-relative'" :aria-label="ariaLabel">
    <IconBell class="icon" :size="24" />
    <span v-if="label" class="inbox-bell-count position-absolute top-0 start-100 translate-middle badge rounded-pill text-white bg-danger">
      {{ label }}
    </span>
  </RouterLink>
</template>

<style scoped>
.inbox-bell {
  border: 0;
}

/* Left of BasePage's .alt-menu-btn (top 10px, right 10px) */
.inbox-bell-floating {
  top: 10px;
  right: 66px;
  z-index: 999;
  background: var(--tblr-bg-surface);
  box-shadow: var(--tblr-box-shadow-sm);
}

.inbox-bell-count {
  font-size: 0.75rem;
}
</style>
